import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const ConfirmationDialog = React.memo(
	({
		dialogTitle = 'Confirmation',
		contentText = 'dialog content text',
		yesText = 'Yes',
		noText = 'No',
		onYes,
		onNo,
		open,
		setOpen,
	}) => {
		const theme = useTheme();
		const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

		const handleClose = () => {
			setOpen(false);
		};

		const handleYes = () => {
			onYes && onYes();
			handleClose();
		};

		const handleNo = () => {
			onNo && onNo();
			handleClose();
		};

		return (
			<>
				<Dialog
					fullScreen={fullScreen}
					open={open}
					onClose={handleClose}
					aria-labelledby='responsive-dialog-title'
				>
					<DialogTitle id='responsive-dialog-title'>{dialogTitle}</DialogTitle>
					<DialogContent>
						<DialogContentText>{contentText}</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							autoFocus
							variant='contained'
							color='error'
							onClick={handleNo}
						>
							{noText}
						</Button>
						<Button
							variant='contained'
							color='success'
							onClick={handleYes}
							autoFocus
						>
							{yesText}
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	}
);

ConfirmationDialog.propTypes = {
	title: PropTypes.string,
	dialogTitle: PropTypes.string.isRequired,
	contentText: PropTypes.string.isRequired,
	yesText: PropTypes.string,
	noText: PropTypes.string,
	onYes: PropTypes.func,
	onNo: PropTypes.func,
	open: PropTypes.bool,
	setOpen: PropTypes.func,
};

export default ConfirmationDialog;
